'use strict';

/*global createObjectCallBack*/

function K2KeyboardFormController() {
  this.keyboard = null;
  this.$form = null;

  this.init();
}

K2KeyboardFormController.prototype = $.extend({}, {
  constructor: 'K2KeyboardFormController',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    _this.$form.on('focus', 'input:text', createObjectCallBack(_this, 'focusInput'));
  },

  //----------------------------------------------------------------------------

  focusInput: function focusInput() {
    var _this = this;

    var $input = _this.$form.find('input:focus:first');
    $input.blur();
    _this.setInputFocus($input);

    return _this;
  },

  setKeyboard: function setKeyboard(keyboard) {
    var _this = this;

    _this.keyboard = keyboard;

    return _this;
  },

  setInputFocus: function setInputFocus($input) {
    var _this = this;

    _this.$form.find('.has-focus').removeClass('has-focus');
    $input.addClass('has-focus');
    _this.keyboard.setCustomInput($input);

    return _this;
  },

  setForm: function setForm($form) {
    var _this = this;

    _this.$form = $form;
    _this.setInputFocus(_this.$form.find('input:text:first'));

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    return _this;
  }
});
